var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ui-select ng-model=\"vm.campaign\" on-select=\"vm.goToCampaign($select.selected)\" ng-required=\"true\" remove-selected=\"false\" class=\"c-select c-select--uiselect c-header-dropdown\"><ui-select-match placeholder=\"{{ 'select'|translate }}\"><campaign-name campaign=\"$select.selected\">{{ option | json }}</campaign-name></ui-select-match><ui-select-choices repeat=\"option['name'] as option in vm.campaigns | filter: $select.search | limitTo: 30\"><campaign-name campaign=\"option\"></campaign-name></ui-select-choices></ui-select>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/header/header-campaigns.jade
 ** module id = 580
 ** module chunks = 0
 **/